import Divider from "@mui/material/Divider";
import Stack from "@mui/material/Stack";
import { type FC, type ReactNode } from "react";
import { Skeleton, SkeletonPreset } from "../Skeleton";
import * as Styled from "./ProfileInfoV2Section.styled";

export type ProfileInfoV2Field = {
    label: string;
    value?: ReactNode;
};

type ProfileInfoV2SectionProps = {
    title: string;
    fields: ProfileInfoV2Field[];
    action?: ReactNode;
    isLoading?: boolean;
};

const emptyValue = "-";

export const ProfileInfoV2Section: FC<ProfileInfoV2SectionProps> = ({
    title,
    fields,
    action,
    isLoading = false,
}) => {
    const visibleFields = isLoading
        ? fields.map((field) => ({
              label: field.label,
              value: <Skeleton preset={SkeletonPreset.TextFullWidth} />,
          }))
        : fields;

    return (
        <Styled.Section>
            <Styled.Header>
                {isLoading ? (
                    <Skeleton preset={SkeletonPreset.SectionTitle} />
                ) : (
                    <>
                        <Styled.Title withoutScale>{title}</Styled.Title>
                        {action}
                    </>
                )}
            </Styled.Header>
            <Styled.Card>
                <Stack spacing={3} divider={<Divider />}>
                    {visibleFields.map((field) => (
                        <Styled.Row key={field.label}>
                            <Styled.Label>
                                {isLoading ? (
                                    <Skeleton preset={SkeletonPreset.TextShort} />
                                ) : field.label}
                            </Styled.Label>
                            <Styled.Value>{field.value ?? emptyValue}</Styled.Value>
                        </Styled.Row>
                    ))}
                </Stack>
            </Styled.Card>
        </Styled.Section>
    );
};
